import {
  NBS_API_EDIT_PROFILE_REQUEST,
  NBS_API_EDIT_PROFILE_SUCCESS,
  NBS_API_EDIT_PROFILE_FAILURE,
  RESET_EDIT_PROFILE,
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_EDIT_PROFILE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request',
      };
    case NBS_API_EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        from: action.from,
        timestamp: new Date().toUTCString(),
        status: 'success',
      };
    case NBS_API_EDIT_PROFILE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail',
      };
    case RESET_EDIT_PROFILE:
      return initialState;
    default:
      return state;
  }
}
